import { createSlice } from "@reduxjs/toolkit";

const tourSlice = createSlice({
  name: "tour",
  initialState: {
    launch: false
  },
  reducers: {
    toggleLaunch: (state, _action) => {
      state.launch = !state.launch
    }
  }
})

export const { toggleLaunch } = tourSlice.actions
/**
 * @param {{ tour: {launch: boolean} }} state 
 * @returns {boolean}
 */
export const selectorTour = (state) => state.tour.launch

export default tourSlice.reducer